import classNames from 'classnames';
import { memo } from 'react';
import './Loader.css';
import React from 'react';

const AVATAAR_LOADER_URL = 'https://share-creator.avataar.ai/static_assets/loader/v2/avataar_loader.gif';
export type LoaderProps = {
    label?: string;
    fullPage?: boolean,
    textStyle?: { [key: string]: string };
    theme?: 'light' | 'dark';
    downloadProgress?: number;
    avtrLoader?: boolean;
    url?: string;
    scale?: number;
    bgColor?: string;
    className?: string;
};
const Loader = memo(({
    label = '',
    theme = 'light',
    textStyle = {
        fontSize: '20px',
    },
    downloadProgress,
    avtrLoader = false,
    url,
    scale,
    bgColor,
    className,
    fullPage = true,
}: LoaderProps) => {
    if (avtrLoader) {
        return (
            <div id="loader" className={classNames('avtr-loader', className)} style={{ backgroundColor: bgColor }}>
                <img
                    style={{ transform: `scale(${scale})` }}
                    alt="avataar loader"
                    src={url || AVATAAR_LOADER_URL}
                />
                <div style={textStyle}>{label}</div>
            </div>
        );
    }
    return (
        <div className={
            classNames(
                'loader-container',
                'flex-column',
                'flex-center-stretch',
                { 'glass-bg gap-15': fullPage, 'gap-10 blur height-100': !fullPage },
                className,
            )
        }
        >
            <img
                src={theme === 'light'
                    ? 'https://share-creator.avataar.ai/static_assets/loader/v2/avataar_loader_black.gif'
                    : 'https://share-creator.avataar.ai/static_assets/loader/v2/avataar_loader_white.gif'}
                alt="Loading"
                width={100}
                height={100}
            />

            {downloadProgress && <div style={textStyle}>{`${downloadProgress}%`}</div>}
            <div style={textStyle}>{label}</div>
        </div>
    );
});

export default Loader;
